"use client";

import { iHolidayQuoteItineraryBlock } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import {
  buildTripModeStaySummaries,
  formatTripModeStayLine,
} from "./build-trip-mode-stay-summaries";
import {
  quoteThemeColorStyles,
  quoteThemeCssVars,
} from "../quote-theme/quote-theme-css-vars";

interface TripModeStaysSummaryProps {
  hotels: iHolidayQuoteItineraryBlock[];
  activeBlockId?: string;
  onSelectStay?: (blockId: string) => void;
}

export function TripModeStaysSummary({
  hotels,
  activeBlockId,
  onSelectStay,
}: TripModeStaysSummaryProps) {
  const stays = buildTripModeStaySummaries(hotels);
  if (stays.length === 0) return null;

  return (
    <div className="space-y-3">
      <h3
        className="text-sm font-semibold uppercase tracking-wide"
        style={quoteThemeColorStyles.primary}
      >
        Your stays
      </h3>
      <ul className="space-y-2.5">
        {stays.map((stay) => {
          const isActive = stay.blockId === activeBlockId;
          return (
            <li key={stay.blockId}>
              <button
                type="button"
                onClick={() => onSelectStay?.(stay.blockId)}
                className="flex w-full items-start gap-3 rounded-xl px-3 py-2.5 text-left text-sm transition-colors hover:bg-gray-50"
                style={
                  isActive
                    ? {
                        backgroundColor: quoteThemeCssVars.primary10,
                      }
                    : undefined
                }
              >
                <span
                  className="mt-1.5 h-2 w-2 rotate-45 flex-shrink-0"
                  style={quoteThemeColorStyles.primaryBg}
                  aria-hidden
                />
                <span className="text-gray-800 leading-relaxed">
                  <span className="font-medium">
                    {stay.nights} night{stay.nights === 1 ? "" : "s"} at{" "}
                    {stay.name}
                  </span>
                  {stay.rating ? (
                    <span className="text-gray-600"> {stay.rating}⭐</span>
                  ) : null}
                  {(stay.roomType || stay.location) && (
                    <span className="text-gray-600">
                      {" "}
                      –{" "}
                      {[stay.roomType, stay.location]
                        .filter(Boolean)
                        .join(", ")}
                    </span>
                  )}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
      <p className="sr-only">
        {stays.map((stay) => formatTripModeStayLine(stay)).join(". ")}
      </p>
    </div>
  );
}
